<template>
    <span class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir anexo"
            @click.stop="confirmarExcluirAnexo()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => ({})
        },

        finalizacaoAnexo: {
            type: Object,
            default: () => ({})
        },

        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluirAnexo() {
            this.$swal({
                title: 'Exclusão de Anexo',
                html: `Confirma a exclusão do anexo ${this.finalizacaoAnexo.nomeArquivoOriginal}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluirAnexo()
                }
            })
        },

        excluirAnexo() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .excluirAnexo({
                    finalizacaoId: this.$route.params.finalizacaoId,
                    finalizacaoAnexoId: this.finalizacaoAnexo.finalizacaoAnexoId
                })
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterFinalizacaoAtualizada')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
